import React from 'react';

type CellProps = {
  className?: string;
  children?: React.ReactNode;
};

export const Cell: React.FC<CellProps> = ({ children, className = '' }) => {
  return <td className={className}>{children}</td>;
};
